export function resolvePropValue(
	obj: any,
	props: string[]
): string | undefined {
	const index = props.find((value: string) => obj[value] != null);
	return index ? obj[index] : undefined;
}
